import React from "react";
import { useTeamModel } from "../teamModel";

import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";

const searchFields = [
    {
        type: SearchTypeEnum.Input,
        placeholder: "标题",
        fieldName: "title"
    },
    {
        type: SearchTypeEnum.Datepicker,
        fieldName: "createTime",
        placeholder: "创建时间",
        format: "YYYY-MM-DD",
    },
]

export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useTeamModel();

    return (
        <YhPageHeader
            title="团队风采"
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            // handleSearch={loadData}
            handleSearch={(params) => loadData(initPgCfg, {...searchParam,...params})}
            handleReset={resetSearchParam}
        />
    );
}